import { Injectable, OnInit, Output } from "@angular/core";
import { firstValueFrom, Observable, Subject, Subscription, take } from "rxjs";
import { LocationsService } from "./Locations.service";
import { MapHelperService } from "src/services/map-helper.service";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { TutorialService } from "../../shared/features/tutorial/services/tutorial.service";
import { PanelInternalLayerService } from "./Panel-Internal-Layer.service";

@Injectable({
  providedIn: "root",
})
export class LocationsMapService {
  private dataGeoJson$: Subject<any> = new Subject();

  mainGeoJsonData: any = null;
  filterGeoJsonData: any = null;
  availabilityFilterGeoJsonData: any = null;

  subscription_SetLocationsGeoJSON: Subscription;
  constructor(
    private locationsService: LocationsService,
    private mapHelperService: MapHelperService,
    private tutorialService: TutorialService,
    private panelInternalLayerService: PanelInternalLayerService
  ) {}

  async GetLocations() {
    console.log("GetLayerGPSGeoJson");
    const data: EstatusJSON = await firstValueFrom(this.locationsService.GetLayerGPSGeoJson().pipe(take(1)));
    if (data.isSuccess == true) {
      this.mainGeoJsonData = JSON.parse(data.result);
    }
  }

  async GetLocationsFilter(filters: any[]) {
    this.locationsService.setLoading(true);
    console.log("GetLocationsFilterGeoJson");
    const data: EstatusJSON = await firstValueFrom(this.locationsService.setLocationsGeoJsonFilter(filters).pipe(take(1)))
    if (data.isSuccess == true) {
      this.filterGeoJsonData = JSON.parse(data.result);
    }
  }

  async GetLocationsAvailabilityFilter(filters: any, initialDate: string, finalDate: string, idLocationCategories: number[]) {
    this.locationsService.setLoading(true);
    console.log("GetLocationsAvailabilityFilterGeoJson");
    const data: EstatusJSON = await firstValueFrom(this.locationsService.GetGeoJsonAvailabilityFilter(filters, initialDate, finalDate, idLocationCategories).pipe(take(1)))
    if (data.isSuccess == true) {
      this.availabilityFilterGeoJsonData = JSON.parse(data.result);
    }
  }

  paintMainGeoJsonData(geoJson: any): boolean {
    this.locationsService.setLoading(true);
    // var pointsSource = this.mapHelperService._map.getSource("pointsSource");
    if (geoJson == null || geoJson == undefined )
      return false;
    try {
      // console.log("updating", geoJson);
      this.mapHelperService.UpdateLayerGeoJson("pointsSource", geoJson);
      this.locationsService.setLoading(false);
      return true;
    } catch (error) {
      this.locationsService.setLoading(false);
      return false;
    }
  }

  paintFilterGeoJsonData(geoJson: any): boolean {
    this.locationsService.setLoading(true);
    if (geoJson == null || geoJson == undefined)
      return false;
    try {
      // console.log("updating", geoJson);
      this.mapHelperService.UpdateLayerGeoJson("filterPointsSource", geoJson);
      this.locationsService.setLoading(false);
      return true;
    } catch (error) {
      this.locationsService.setLoading(false);
      return false;
    }
  }
}
